import { render, staticRenderFns } from "./bizparam.vue?vue&type=template&id=c89f0a3e&scoped=true&"
import script from "./bizparam.vue?vue&type=script&lang=js&"
export * from "./bizparam.vue?vue&type=script&lang=js&"
import style0 from "./bizparam.vue?vue&type=style&index=0&id=c89f0a3e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f0a3e",
  null
  
)

export default component.exports